import React from 'react';
import CreatableSelect from 'react-select/creatable';
import classnames from 'classnames';
import { dropdownStyles } from './styles';

// For customized modules see app/javascript/assets/js/approach-react/verizonCustomerCaseV2024/conceptSideBySide/components/filtersEditor.js:126
// options = [{ value: ..., label: ... }, ...]
const Dropdown = ({
  value, options, onChange, searchable, multi, maxMenuHeight = 300,
  disabled, placeholder = 'Select...', canCreate = false, customStyles,
  className
}) => {
  const handleOnChange = (newValue) => {
    onChange(newValue);
  };
  const isValidNewOption = () => (canCreate);

  const formatGroupLabel = (data) => (<div><span>{data.label}</span></div>);

  return (
    <CreatableSelect
      // defaultMenuIsOpen
      // defaultValue
      value={ value }
      className={ classnames("react-select-container", className) }
      classNamePrefix="react-select"
      options={ options }
      onChange={ handleOnChange }
      isSearchable={ searchable }
      isMulti={ multi }
      autosize={ false }
      maxMenuHeight={ maxMenuHeight }
      styles={ customStyles || dropdownStyles }
      isDisabled={ disabled }
      placeholder={ placeholder }
      isValidNewOption={ isValidNewOption }
      formatGroupLabel={ formatGroupLabel }
    />
  );
};

export default Dropdown;
